module.exports = __webpack_public_path__ + "static/media/997722.db868b5d.jpg";